var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, Suspense, useRef, useMemo } from "react";
import Html from './html';
import { LazyLoadModules } from "./helpers/lazyLoadModules";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { listenDeviceRemoved, listenDisposeCookies, pageClientQueryData, checkVppaCompliance, embedCode, handlePageViewEvent, handleUserLogout, initGTM, fireLogout, fetchUserDetails, listenToChannel, handleUserTransactions, handleQueryUrls, verifyMagicLink, handleStatusGaCalls, getQueryParams, convertToJSON, capitalize, getUnixTimestamp, subscriptionData, fetchAndSetupPlanGroups, handleSeviceTypes, isTveOnlyLoginEnabled, setPageTree, isContentPage, getPlanByPlanId, structuredPlan, isExternalAuthUrl, isNavigateToExternalUrl } from "./helpers";
import "./styles/siteStyles.scss";
import { loadSiteStyles } from "./styles/helpers";
import { initializeConnection, syncSSEStore } from "./SSE";
import pubsub from "@viewlift/pubsub";
import './index.scss';
import Cookies from 'js-cookie';
import { BroadcastChannel } from 'broadcast-channel';
import './cookie.scss';
import { subscribeUserCreated, unsubscribeUserCreated } from "./OnBoarding-V2/Events/utils.events";
import { parseJSON } from "./OnBoarding-V2/utils/parseJSON";
import { ANALYTICSEVENTS } from "./OnBoarding-V2/LoginV2/Helpers/analyticsMap.js";
import logger from "./logger";
import loadable from '@loadable/component';
import { anonymousUserPushNotification, initializeWebWorker, isBrazeEnabled, registerCustomSW, requestUserPermission } from "../registerSW.js";
import ketchCookieConsent from './components/CookieConsent/ketch.js';
import NavFocusSkipper from "./components/SkipToMainContent";
import { ErrorBoundary } from "react-error-boundary";
import { Helmet } from "react-helmet";
import { pushAdobeAnalyticsData } from "./AdobeAnalytics/AdobeExtention.js";
import useAdobeAnalyticsSdk from "./AdobeAnalytics/useAdobeAnalyticsSdk.js";
import { getStorageItem, setStorageItem } from "./helpers/storageManager.js";
import { checkTeamsAvailability } from "./helpers/checkTeamsAvailability";
export var App = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65;
    var siteConfig = _a.siteConfig, pageData = _a.pageData, browserDetails = _a.browserDetails, xApiKey = _a.xApiKey, cachedAPI = _a.cachedAPI, apiBaseUrl = _a.apiBaseUrl, sseBaseUrl = _a.sseBaseUrl, analyticsBaseUrl = _a.analyticsBaseUrl, wssBaseUrl = _a.wssBaseUrl, env = _a.env, ip = _a.ip, embedCodeToken = _a.embedCodeToken, toolsUrl = _a.toolsUrl, templateUrl = _a.templateUrl, requestId = _a.requestId;
    var _66 = __read(useState(pageData), 2), pageMetaData = _66[0], setPageData = _66[1];
    var _67 = __read(useState(null), 2), VLCookieConsent = _67[0], setVLCookieConsent = _67[1];
    var _68 = __read(useState(null), 2), activeSplash = _68[0], setActiveSplash = _68[1];
    var _69 = __read(useState(false), 2), isTveEnabled = _69[0], setIsTveEnabled = _69[1];
    var _70 = __read(useState(null), 2), SnackbarComponent = _70[0], setSnackbarComponent = _70[1];
    //const [showMasthead, setShowMasthead] = useState(false)
    //const windowSizeRef:any = useRef({ width: null });
    var _71 = __read(useSearchParams(), 1), searchParams = _71[0];
    var _72 = __read(useState(false), 2), isUpgrade = _72[0], setIsUpgrade = _72[1];
    var navigate = useNavigate();
    var snackbarRef = useRef(null);
    var NotFound404 = React.lazy(function () { return import("./components/404"); });
    var CmsMenu = loadable(function () { return import("./components/CmsMenu/index.js"); });
    var V2TveLogin = loadable(function () { return import("./components/AdobeRestV2/V2TveLogin"); });
    var PersonalizationBanner = loadable(function () { return import('./modules/PersonalizationBanner'); });
    var SplashLoader = loadable(function () { return import("./modules/SplashScreens"); });
    var UpgradeWrapper = loadable(function () { return import("./OnBoarding-V2/utils/UpgradeWrapper/index"); });
    var LocationServicesModal = loadable(function () { return import('./components/LocationServicesModal'); });
    var previouslyFocusedElement = useRef(null);
    var analyticListenerReady = useRef(null);
    var IntervalInstance;
    var configMessages = {};
    var disableVlCookieConsent = false;
    var zipcodeEnabledForPersonalizationChoices = false;
    var isAuthWithPwdFlow = false;
    var oneTrustInterval = null;
    var handleInitGtm = function () {
        oneTrustInterval = setInterval(function () {
            var _a;
            if ((_a = window === null || window === void 0 ? void 0 : window.OneTrust) === null || _a === void 0 ? void 0 : _a.IsAlertBoxClosed()) {
                if (oneTrustInterval)
                    clearInterval(oneTrustInterval);
                pubsub.publish("one-trust-setup", true);
            }
        }, 3000);
    };
    if (typeof window !== "undefined") {
        disableVlCookieConsent = ((_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.privacy) === null || _d === void 0 ? void 0 : _d.disableVlCookieConsent) || false;
        var isAdobeEnabled = (_h = (_g = (_f = (_e = window === null || window === void 0 ? void 0 : window.app_data) === null || _e === void 0 ? void 0 : _e.appcmsPlatform) === null || _f === void 0 ? void 0 : _f.analytics) === null || _g === void 0 ? void 0 : _g.adobeConfig) === null || _h === void 0 ? void 0 : _h.enabled;
        if (isAdobeEnabled) {
            useAdobeAnalyticsSdk();
        }
        if (disableVlCookieConsent) {
            handleInitGtm();
        }
        configMessages = {
            cookieModalHeadingTitle: (_l = (_k = (_j = window === null || window === void 0 ? void 0 : window.app_data) === null || _j === void 0 ? void 0 : _j.appcmsMain) === null || _k === void 0 ? void 0 : _k.genericMessages) === null || _l === void 0 ? void 0 : _l.cookieModalHeadingTitle,
            cookieModalDescription: (_p = (_o = (_m = window === null || window === void 0 ? void 0 : window.app_data) === null || _m === void 0 ? void 0 : _m.appcmsMain) === null || _o === void 0 ? void 0 : _o.genericMessages) === null || _p === void 0 ? void 0 : _p.cookieModalDescription,
            requiredCookieAccordionTitle: (_s = (_r = (_q = window === null || window === void 0 ? void 0 : window.app_data) === null || _q === void 0 ? void 0 : _q.appcmsMain) === null || _r === void 0 ? void 0 : _r.genericMessages) === null || _s === void 0 ? void 0 : _s.requiredCookieAccordionTitle,
            requiredCookieAccordionDescription: (_v = (_u = (_t = window === null || window === void 0 ? void 0 : window.app_data) === null || _t === void 0 ? void 0 : _t.appcmsMain) === null || _u === void 0 ? void 0 : _u.genericMessages) === null || _v === void 0 ? void 0 : _v.requiredCookieAccordionDescription,
            optionalCookieAccordionTitle: (_y = (_x = (_w = window === null || window === void 0 ? void 0 : window.app_data) === null || _w === void 0 ? void 0 : _w.appcmsMain) === null || _x === void 0 ? void 0 : _x.genericMessages) === null || _y === void 0 ? void 0 : _y.optionalCookieAccordionTitle,
            optionalCookieAccordionDescription: (_1 = (_0 = (_z = window === null || window === void 0 ? void 0 : window.app_data) === null || _z === void 0 ? void 0 : _z.appcmsMain) === null || _0 === void 0 ? void 0 : _0.genericMessages) === null || _1 === void 0 ? void 0 : _1.optionalCookieAccordionDescription,
            functionalCookieTitle: (_4 = (_3 = (_2 = window === null || window === void 0 ? void 0 : window.app_data) === null || _2 === void 0 ? void 0 : _2.appcmsMain) === null || _3 === void 0 ? void 0 : _3.genericMessages) === null || _4 === void 0 ? void 0 : _4.functionalCookieTitle,
            functionalCookieDescription: (_7 = (_6 = (_5 = window === null || window === void 0 ? void 0 : window.app_data) === null || _5 === void 0 ? void 0 : _5.appcmsMain) === null || _6 === void 0 ? void 0 : _6.genericMessages) === null || _7 === void 0 ? void 0 : _7.functionalCookieDescription,
            performanceCookieTitle: (_10 = (_9 = (_8 = window === null || window === void 0 ? void 0 : window.app_data) === null || _8 === void 0 ? void 0 : _8.appcmsMain) === null || _9 === void 0 ? void 0 : _9.genericMessages) === null || _10 === void 0 ? void 0 : _10.performanceCookieTitle,
            performanceCookieDescription: (_13 = (_12 = (_11 = window === null || window === void 0 ? void 0 : window.app_data) === null || _11 === void 0 ? void 0 : _11.appcmsMain) === null || _12 === void 0 ? void 0 : _12.genericMessages) === null || _13 === void 0 ? void 0 : _13.performanceCookieDescription,
            cookieAcceptBtnLabel: (_16 = (_15 = (_14 = window === null || window === void 0 ? void 0 : window.app_data) === null || _14 === void 0 ? void 0 : _14.appcmsMain) === null || _15 === void 0 ? void 0 : _15.genericMessages) === null || _16 === void 0 ? void 0 : _16.cookieAcceptBtnLabel,
            cookieRejectBtnLabel: (_19 = (_18 = (_17 = window === null || window === void 0 ? void 0 : window.app_data) === null || _17 === void 0 ? void 0 : _17.appcmsMain) === null || _18 === void 0 ? void 0 : _18.genericMessages) === null || _19 === void 0 ? void 0 : _19.cookieRejectBtnLabel,
            cookieSaveSettingsBtnLabel: (_22 = (_21 = (_20 = window === null || window === void 0 ? void 0 : window.app_data) === null || _20 === void 0 ? void 0 : _20.appcmsMain) === null || _21 === void 0 ? void 0 : _21.genericMessages) === null || _22 === void 0 ? void 0 : _22.cookieSaveSettingsBtnLabel,
            cookieSettingsModalTitle: (_25 = (_24 = (_23 = window === null || window === void 0 ? void 0 : window.app_data) === null || _23 === void 0 ? void 0 : _23.appcmsMain) === null || _24 === void 0 ? void 0 : _24.genericMessages) === null || _25 === void 0 ? void 0 : _25.cookieSettingsModalTitle,
            cookieSettingsModalDescription: (_28 = (_27 = (_26 = window === null || window === void 0 ? void 0 : window.app_data) === null || _26 === void 0 ? void 0 : _26.appcmsMain) === null || _27 === void 0 ? void 0 : _27.genericMessages) === null || _28 === void 0 ? void 0 : _28.cookieSettingsModalDescription,
            cookieSettingsMoreInfoTitle: (_31 = (_30 = (_29 = window === null || window === void 0 ? void 0 : window.app_data) === null || _29 === void 0 ? void 0 : _29.appcmsMain) === null || _30 === void 0 ? void 0 : _30.genericMessages) === null || _31 === void 0 ? void 0 : _31.cookieSettingsMoreInfoTitle,
            cookieSettingsMoreInfoDescription: (_34 = (_33 = (_32 = window === null || window === void 0 ? void 0 : window.app_data) === null || _32 === void 0 ? void 0 : _32.appcmsMain) === null || _33 === void 0 ? void 0 : _33.genericMessages) === null || _34 === void 0 ? void 0 : _34.cookieSettingsMoreInfoDescription,
            cookieLetMeChooseButtonLabel: (_37 = (_36 = (_35 = window === null || window === void 0 ? void 0 : window.app_data) === null || _35 === void 0 ? void 0 : _35.appcmsMain) === null || _36 === void 0 ? void 0 : _36.genericMessages) === null || _37 === void 0 ? void 0 : _37.cookieLetMeChooseButtonLabel,
            privacyPolicyLinkLabel: (_40 = (_39 = (_38 = window === null || window === void 0 ? void 0 : window.app_data) === null || _38 === void 0 ? void 0 : _38.appcmsMain) === null || _39 === void 0 ? void 0 : _39.genericMessages) === null || _40 === void 0 ? void 0 : _40.privacyPolicyLinkLabel,
            contactUsLinkLabel: (_43 = (_42 = (_41 = window === null || window === void 0 ? void 0 : window.app_data) === null || _41 === void 0 ? void 0 : _41.appcmsMain) === null || _42 === void 0 ? void 0 : _42.genericMessages) === null || _43 === void 0 ? void 0 : _43.contactUsLinkLabel
        };
        zipcodeEnabledForPersonalizationChoices = ((_46 = (_45 = (_44 = window === null || window === void 0 ? void 0 : window.app_data) === null || _44 === void 0 ? void 0 : _44.appcmsMain) === null || _45 === void 0 ? void 0 : _45.geoRestrict) === null || _46 === void 0 ? void 0 : _46.zipcodeEnabledForPersonalizationChoices) || false;
        isAuthWithPwdFlow = ((_50 = (_49 = (_48 = (_47 = window === null || window === void 0 ? void 0 : window.app_data) === null || _47 === void 0 ? void 0 : _47.appcmsMain) === null || _48 === void 0 ? void 0 : _48.ssoConfig) === null || _49 === void 0 ? void 0 : _49.nhl) === null || _50 === void 0 ? void 0 : _50.isEnabled) || false;
    }
    var shouldShowLocationModal = zipcodeEnabledForPersonalizationChoices && isAuthWithPwdFlow;
    var location = useLocation();
    useEffect(function () {
        import("./instrumentation").then(function (_a) {
            var Instrumentation = _a.Instrumentation;
            return Instrumentation.initSentry();
        });
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        var importVLCookieConsent = function () { return __awaiter(void 0, void 0, void 0, function () {
            var module_1, VLCookieConsent_1, moduleWithDefault, VLCookieConsent_2, error_1, getCookie;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, import('@viewlift/cookie-consent/vlCookieConsent/esm/App')];
                    case 1:
                        module_1 = _b.sent();
                        if ('VLCookieConsent' in module_1) {
                            VLCookieConsent_1 = module_1.VLCookieConsent;
                            setVLCookieConsent(function () { return VLCookieConsent_1; });
                        }
                        else if ('default' in module_1) {
                            moduleWithDefault = module_1;
                            if (moduleWithDefault && moduleWithDefault.default) {
                                VLCookieConsent_2 = moduleWithDefault.default;
                                setVLCookieConsent(function () { return VLCookieConsent_2; });
                            }
                        }
                        else {
                            logger("Invalid VLCookieConsent module structure: ".concat(module_1), "error");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        logger("Error importing VLCookieConsent: ".concat(error_1), "error");
                        return [3 /*break*/, 3];
                    case 3:
                        if (Cookies.get("cc_cookie")) {
                            getCookie = JSON.parse(Cookies.get("cc_cookie"));
                            if (((_a = getCookie === null || getCookie === void 0 ? void 0 : getCookie.level) === null || _a === void 0 ? void 0 : _a.includes("performanceCookie")) && !window.fireGaEvents) {
                                window.fireGaEvents = true;
                                initGTM();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        // Call the dynamic import function
        var externalAuthUrl = isExternalAuthUrl() || null;
        var isAppAccessing = (!externalAuthUrl && getQueryParams(window.location.href)) || null;
        var isKetchEnabled = ((_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.privacy) === null || _c === void 0 ? void 0 : _c.ketchCookie) === null || _d === void 0 ? void 0 : _d.enable) || false;
        if (typeof (window) !== undefined && !(window.location.href.indexOf("embed/player") > -1) && !isAppAccessing) {
            //Initialize the beacon call, user accepts the cookie consent or not
            analyticListenerReady.current = import("./analyticListener").then(function (_a) {
                var listenAnalyticEvents = _a.listenAnalyticEvents, listenFBEvents = _a.listenFBEvents, listenConviva = _a.listenConviva;
                listenAnalyticEvents();
                listenFBEvents();
                listenConviva();
            });
            if (!externalAuthUrl) {
                if (!disableVlCookieConsent) {
                    importVLCookieConsent();
                }
                else if (isKetchEnabled) {
                    ketchCookieConsent();
                    window.fireGaEvents = true;
                    initGTM();
                }
                else {
                    pubsub.subscribe("one-trust-setup", function (data) {
                        var OptanonConsent = Cookies.get("OptanonConsent");
                        var params = new URLSearchParams(OptanonConsent);
                        var parsedData = Object.fromEntries(params.entries());
                        var groups = convertToJSON(parsedData === null || parsedData === void 0 ? void 0 : parsedData.groups);
                        if (groups) {
                            if (groups['C0004'] && !window.fireGaEvents) {
                                window.fireGaEvents = true;
                                initGTM();
                            }
                        }
                    });
                }
            }
        }
        subscriptionData();
    }, []);
    useEffect(function () {
        var _a;
        if (typeof (window) !== undefined && ((_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain.features.embeddedCode)) {
            var isAppAccessing = getQueryParams(window.location.href) || null;
            if (isAppAccessing) {
                document.body.classList.add("remove-oneTrust");
            }
            embedCode();
        }
    }, []);
    // Show no teams available location modal based on user's zip code
    useEffect(function () {
        var checkAndShowLocationModal = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isTeamsAvailable, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, checkTeamsAvailability()];
                    case 1:
                        isTeamsAvailable = _a.sent();
                        if (isTeamsAvailable) {
                            pubsub.publish('hide-location-services-modal');
                        }
                        else {
                            pubsub.publish('show-location-services-modal');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Error checking teams availability:', error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (shouldShowLocationModal) {
            checkAndShowLocationModal();
        }
    }, []);
    var checkForIsRedirected = function () { return __awaiter(void 0, void 0, void 0, function () {
        var redirected, comparePath;
        var _a, _b;
        return __generator(this, function (_c) {
            redirected = getStorageItem("isRedirected");
            comparePath = (_a = redirected === null || redirected === void 0 ? void 0 : redirected.path) === null || _a === void 0 ? void 0 : _a.split("?");
            comparePath = (comparePath === null || comparePath === void 0 ? void 0 : comparePath.length) ? comparePath[0] : redirected === null || redirected === void 0 ? void 0 : redirected.path;
            if (location.pathname === comparePath || (location === null || location === void 0 ? void 0 : location.pathname) === "/") {
                setStorageItem("isRedirected", __assign(__assign({}, redirected), { redirect: false, isDetailPage: false, isUpgradePlan: false, isCheckout: false }));
                if (!((_b = redirected === null || redirected === void 0 ? void 0 : redirected.contentSubscriptionFlow) === null || _b === void 0 ? void 0 : _b.enabled) || location.pathname === (redirected === null || redirected === void 0 ? void 0 : redirected.path)) {
                    sessionStorage.removeItem("contentPlanIds");
                    sessionStorage.removeItem("toShowTve");
                }
                sessionStorage.removeItem('isUpgradeAvailable');
            }
            if (location.pathname != '/redeem-authentication') {
                Cookies.set('RedirectToRedeem', false);
            }
            return [2 /*return*/];
        });
    }); };
    var redirectToPath = function (data) {
        var navigateToExternalUrl = isNavigateToExternalUrl();
        if (navigateToExternalUrl) {
            // We are trying to open an Android/IOS app(Deep link), do NOT use navigate.
            window.location.href = navigateToExternalUrl;
            return;
        }
        else {
            navigate(data);
        }
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        initializeWebWorker();
        if (sessionStorage.getItem('reloadAfterNavigation') === 'true') {
            sessionStorage.removeItem('reloadAfterNavigation');
            window.location.reload();
            return;
        }
        pubsub.subscribe('redirect', redirectToPath);
        sessionStorage.setItem("transactionStarted", JSON.stringify(false));
        var searchTerm = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.searchTerm) || null;
        pageClientQueryData(pageData, setPageData, { status: false }, searchTerm);
        pubsub.publish('apploading', false);
        var isCheckoutInitiate = parseJSON(sessionStorage.getItem('checkout-initiate') || '');
        if (isCheckoutInitiate) {
            sessionStorage.removeItem('checkout-initiate');
            var currentStoredPlan = parseJSON(sessionStorage.getItem('currentPlan') || '');
            var checkoutInitPageDetails = parseJSON(sessionStorage.getItem('checkoutInitPageData') || '');
            var eventData = {
                "pageUrl": checkoutInitPageDetails === null || checkoutInitPageDetails === void 0 ? void 0 : checkoutInitPageDetails.pageUrl,
                "monetizationType": currentStoredPlan === null || currentStoredPlan === void 0 ? void 0 : currentStoredPlan.type,
                "message": 'page change'
            };
            pubsub.publish('user-analytics', { ename: ANALYTICSEVENTS.NEW_ONBOARDING_CHECKOUT_CANCELED, data: eventData });
            handleStatusGaCalls({ eventName: 'checkout_cancellation', subSection: null, type: 'cancellation', reason: 'page change', status: 'cancellation', action: 'Cancel', paymentStatus: null, eventCategory: 'Checkout', section: 'checkout', additionalLabel: null });
        }
        loadSiteStyles();
        if ((pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/tos' && (pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/privacy-policy' && (pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/offers' && (pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/agreement' && (pageData === null || pageData === void 0 ? void 0 : pageData.path) != '/checkout')
            checkVppaCompliance();
        checkForIsRedirected();
        syncSSEStore();
        var bodyTag = document.getElementsByTagName("body");
        if (bodyTag.length > 0) {
            bodyTag[0].style.overflowY = "unset";
            bodyTag[0].style.position = "unset";
        }
        if ((location === null || location === void 0 ? void 0 : location.pathname) === '/') {
            sessionStorage.removeItem("contentPlanIds");
            sessionStorage.removeItem("toShowTve");
            sessionStorage.removeItem("splashLoginEmail");
            sessionStorage.removeItem("splashSignupEmail");
        }
        var isTveEnabled = isTveOnlyLoginEnabled();
        setIsTveEnabled(isTveEnabled);
        if (isTveEnabled && (location.pathname == '/authentication' || location.pathname == '/checkout')) {
            navigate('/');
        }
        if (typeof (window) !== undefined && ((_e = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsPlatform) === null || _c === void 0 ? void 0 : _c.analytics) === null || _d === void 0 ? void 0 : _d.convivaConfig) === null || _e === void 0 ? void 0 : _e.enabled)) {
            pubsub.publish('conviva-page-change', null);
        }
    }, [location]);
    useEffect(function () {
        if (typeof window === "undefined")
            return;
        // TODO: also need to handle when module order changes on the page - because then complete page data needs to be fetched again
        var timeout = null;
        try {
            pubsub.subscribe('page-modules-updated', function (data) {
                var _a, _b, _c;
                if (!data || !data.updatedModules || data.updatedModules.length === 0 || !data.pageId || !data.site)
                    return console.warn('Invalid data received for page-modules-updated event');
                // check if user is on the same page where modules are updated
                if (data.pageId !== ((_a = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _a === void 0 ? void 0 : _a.id))
                    return console.info('User is not on the same page where modules are updated');
                // check if the moduleId in updatedModules exists in the current page modules
                var currentModuleIds = ((_c = (_b = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _b === void 0 ? void 0 : _b.modules) === null || _c === void 0 ? void 0 : _c.map(function (mod) { return mod.id; })) || [];
                var isModuleUpdated = data.updatedModules.some(function (moduleId) { return currentModuleIds.includes(moduleId); });
                if (!isModuleUpdated)
                    return console.info('No matching modules found on the current page for the updated modules');
                // debounce call with a delay between 5s to 50s
                var randomDelay = Math.floor(Math.random() * (50000 - 5000 + 1)) + 5000; // random delay between 5s to 50s
                console.info("Received page-modules-updated event. Fetching updated module data in ".concat(randomDelay, " ms..."));
                // Clear any existing timeout to avoid multiple calls
                if (timeout)
                    clearTimeout(timeout);
                timeout = setTimeout(function () {
                    console.info('Fetching updated module data after page-modules-updated event...');
                    pageClientQueryData(pageMetaData, setPageData, { status: false }, null, data.updatedModules, true);
                }, randomDelay);
            });
        }
        catch (err) {
            console.error("Error subscribing to page-modules-updated event: ".concat(err));
        }
        return function () {
            if (timeout)
                clearTimeout(timeout);
        };
    }, []);
    var handleUserCreated = function (data) {
        var _a;
        if (data === null || data === void 0 ? void 0 : data.status) {
            initializeConnection({
                site: (_a = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _a === void 0 ? void 0 : _a.siteInternalName,
                sseBaseUrl: sseBaseUrl
            });
            unsubscribeUserCreated(function (data) { return handleUserCreated(data); });
        }
    };
    var clevertapInit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var AuthenticationStore, userInfo, subscriptionData, userProfile;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            AuthenticationStore = getStorageItem('AuthenticationStore');
            userInfo = AuthenticationStore === null || AuthenticationStore === void 0 ? void 0 : AuthenticationStore.user;
            if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) {
                subscriptionData = userInfo.subscription || {};
                userProfile = {
                    'Name': userInfo.name,
                    'Email': userInfo.email,
                    'Identity': userInfo.userId,
                    'Phone': userInfo && userInfo.phoneNumber ? ((typeof userInfo.phoneNumber === 'string' && (userInfo.phoneNumber.charAt(0) !== '+')) ? JSON.parse(userInfo.phoneNumber) : userInfo.phoneNumber) : "",
                    'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
                    'registration_method': userInfo.provider,
                    'registration_platform': userInfo.registerdVia && capitalize(userInfo.registerdVia.split('_')[0]),
                    'registration_date': getUnixTimestamp((userInfo.registeredOn && userInfo.registeredOn.split("T")[0]) || null),
                    'registration_country': userInfo.country,
                    'MSG-whatsapp': userInfo && userInfo.whatsappConsent ? userInfo.whatsappConsent : false,
                    'MSG-email': userInfo && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailConsent) ? userInfo.emailConsent : false,
                };
                if (userInfo.isSubscribed && subscriptionData && subscriptionData.subscriptionInfo) {
                    Object.assign(userProfile, {
                        // 'paymentMode': subscriptionData?.subscriptionInfo?.cardType || null,
                        'paymentHandler': ((_a = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _a === void 0 ? void 0 : _a.paymentHandler) || null,
                        'subscriptionStartDate': getUnixTimestamp((((_b = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _b === void 0 ? void 0 : _b.subscriptionStartDate) && ((_c = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _c === void 0 ? void 0 : _c.subscriptionStartDate.split("T")[0])) || null),
                        'subscriptionEndDate': getUnixTimestamp((((_d = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _d === void 0 ? void 0 : _d.subscriptionEndDate) && ((_e = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _e === void 0 ? void 0 : _e.subscriptionEndDate.split("T")[0])) || null),
                        // 'transactionId': subscriptionInfo.vlTransactionId || null,
                        'discountAmount': ((_f = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _f === void 0 ? void 0 : _f.planAmount) || null,
                        'paymentPlanID': ((_g = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _g === void 0 ? void 0 : _g.planId) || null,
                        'freeTrial': ((_h = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _h === void 0 ? void 0 : _h.freeTrial) ? 'Yes' : 'No',
                        'country': ((_j = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _j === void 0 ? void 0 : _j.countryCode) || null,
                        'currency': ((_k = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _k === void 0 ? void 0 : _k.currencyCode) || null,
                        'amount': ((_l = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _l === void 0 ? void 0 : _l.planAmount) || null,
                    });
                }
                import("./clevertap")
                    .then(function (_a) {
                    var initCleverTap = _a.initCleverTap, addUserProfile = _a.addUserProfile;
                    return Promise.resolve(initCleverTap())
                        .then(function () { return Promise.resolve(addUserProfile('Site', userProfile, true)); });
                })
                    .then(function () {
                    // console.log("CleverTap functions executed successfully.");
                })
                    .catch(function (error) {
                    console.error("Error executing clevertap functions:", error);
                });
                requestUserPermission();
            }
            else {
                import("./clevertap")
                    .then(function (_a) {
                    var initCleverTap = _a.initCleverTap;
                    return Promise.resolve(initCleverTap())
                        .then(function () { return anonymousUserPushNotification === null || anonymousUserPushNotification === void 0 ? void 0 : anonymousUserPushNotification(); });
                })
                    .then(function () {
                    // console.log("CleverTap functions executed successfully.");
                })
                    .catch(function (error) {
                    console.error("Error executing clevertap functions:", error);
                });
            }
            return [2 /*return*/];
        });
    }); };
    var initiateInterval = function () {
        var _a;
        var storageName = "".concat((_a = siteConfig.site) === null || _a === void 0 ? void 0 : _a.siteInternalName, "-lastTimestamp");
        IntervalInstance = setInterval(function () {
            var _a, _b;
            var lastTimestamp = localStorage.getItem(storageName);
            var broadcastHeartbeat = sessionStorage.getItem('broadcast-heartbeat');
            var currentTime = new Date().getTime();
            var channelName = "".concat((_a = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _a === void 0 ? void 0 : _a.siteInternalName, "-channel");
            var bc = new BroadcastChannel(channelName);
            if ((!broadcastHeartbeat || (currentTime - parseInt(broadcastHeartbeat)) > 20000) && lastTimestamp && (currentTime - parseInt(lastTimestamp)) < 20000) {
                listenToChannel(bc);
            }
            if (!lastTimestamp || (currentTime - parseInt(lastTimestamp)) > 20000) {
                initializeConnection({
                    site: (_b = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _b === void 0 ? void 0 : _b.siteInternalName,
                    sseBaseUrl: sseBaseUrl
                });
            }
        }, 20000);
    };
    useEffect(function () {
        clevertapInit();
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var isTveAuthenticated = handleQueryUrls();
        registerCustomSW();
        if (typeof window !== 'undefined' && !isContentPage()) {
            setPageTree();
            if (isTveAuthenticated)
                return;
            pushAdobeAnalyticsData({ eventName: "Page Load", config: { type: "page load" } });
        }
        var storageName = "".concat((_a = siteConfig.site) === null || _a === void 0 ? void 0 : _a.siteInternalName, "-lastTimestamp");
        var lastTimestamp = localStorage.getItem(storageName);
        var currentTime = new Date().getTime();
        var channelName = "".concat((_b = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _b === void 0 ? void 0 : _b.siteInternalName, "-channel");
        var bc = new BroadcastChannel(channelName);
        var adobeVersion = ((_e = (_d = (_c = window === null || window === void 0 ? void 0 : window.app_data) === null || _c === void 0 ? void 0 : _c.appcmsPlatform) === null || _d === void 0 ? void 0 : _d.tveSettings) === null || _e === void 0 ? void 0 : _e.version) || "v1";
        if (!lastTimestamp || (currentTime - parseInt(lastTimestamp)) > 20000) {
            initializeConnection({
                site: (_f = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.site) === null || _f === void 0 ? void 0 : _f.siteInternalName,
                sseBaseUrl: sseBaseUrl
            });
            initiateInterval();
        }
        else {
            bc.postMessage("ping");
            listenToChannel(bc);
            initiateInterval();
            logger("joined a existing channel", "info");
        }
        (analyticListenerReady.current || Promise.resolve()).then(function () {
            handlePageViewEvent(pageData, { status: false });
        });
        listenDisposeCookies();
        listenDeviceRemoved();
        if (window && typeof (window) !== undefined) {
            var store = getStorageItem('AuthenticationStore');
            var token = Cookies.get('token') && JSON.parse(Cookies.get('token'));
            if ((_g = store === null || store === void 0 ? void 0 : store.user) === null || _g === void 0 ? void 0 : _g.userId) {
                handleUserTransactions();
                if (!(token === null || token === void 0 ? void 0 : token.refreshToken))
                    fireLogout();
                if (handleSeviceTypes().TVE && adobeVersion == 'v1') {
                    import('./helpers/loadTve').then(function (module) { return __awaiter(void 0, void 0, void 0, function () {
                        var loadtve;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    loadtve = module.default;
                                    return [4 /*yield*/, loadtve()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
            }
            handleUserLogout((_h = store === null || store === void 0 ? void 0 : store.user) === null || _h === void 0 ? void 0 : _h.userId);
        }
        fetchAndSetupPlanGroups();
        subscribeUserCreated(function (data) { return handleUserCreated(data); });
        return (function () {
            clearInterval(IntervalInstance);
        });
    }, []);
    useEffect(function () {
        var queryString = document.location.search.slice(1);
        if (queryString.includes('utm_')) {
            import('./utm').then(function (utmFunc) {
                var utm = utmFunc.utm;
                utm();
            });
        }
        var brazeObj = isBrazeEnabled();
        if (brazeObj.enabled) {
            import(
            /* webpackExports: ["initialize", "openSession","requestPushPermission","isPushSupported","subscribeToInAppMessage","isPushPermissionGranted","isPushBlocked","InAppMessage","showInAppMessage","automaticallyShowInAppMessages"] */
            "@braze/web-sdk").then(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
                var store, userId;
                var _c, _d, _e, _f;
                var initialize = _b.initialize, openSession = _b.openSession, requestPushPermission = _b.requestPushPermission, isPushSupported = _b.isPushSupported, automaticallyShowInAppMessages = _b.automaticallyShowInAppMessages, isPushPermissionGranted = _b.isPushPermissionGranted, isPushBlocked = _b.isPushBlocked, changeUser = _b.changeUser, getUser = _b.getUser;
                return __generator(this, function (_g) {
                    initialize(brazeObj === null || brazeObj === void 0 ? void 0 : brazeObj.apiKey, {
                        baseUrl: brazeObj === null || brazeObj === void 0 ? void 0 : brazeObj.baseUrl,
                        enableLogging: true,
                        manageServiceWorkerExternally: true
                    });
                    requestPushPermission();
                    automaticallyShowInAppMessages();
                    store = getStorageItem('AuthenticationStore');
                    userId = (_c = store === null || store === void 0 ? void 0 : store.user) === null || _c === void 0 ? void 0 : _c.userId;
                    if (userId && typeof changeUser === 'function') {
                        changeUser(userId);
                        if (((_d = store === null || store === void 0 ? void 0 : store.user) === null || _d === void 0 ? void 0 : _d.email) && typeof getUser === 'function')
                            (_e = getUser()) === null || _e === void 0 ? void 0 : _e.setEmail((_f = store === null || store === void 0 ? void 0 : store.user) === null || _f === void 0 ? void 0 : _f.email);
                    }
                    else {
                        // if user is not logged will wait for user to get authenticated
                        pubsub.subscribe('isAuthenticated', function (data) {
                            var _a;
                            if (((data === null || data === void 0 ? void 0 : data.id) || (data === null || data === void 0 ? void 0 : data.userId)) && typeof changeUser === 'function')
                                changeUser((data === null || data === void 0 ? void 0 : data.id) || (data === null || data === void 0 ? void 0 : data.userId));
                            if ((data === null || data === void 0 ? void 0 : data.email) && typeof getUser === 'function') {
                                (_a = getUser()) === null || _a === void 0 ? void 0 : _a.setEmail(data === null || data === void 0 ? void 0 : data.email);
                            }
                        });
                    }
                    openSession();
                    // not supported on safari, need an alternative
                    if (typeof window !== "undefined") {
                        window.addEventListener("beforeunload", function (evt) {
                            console.log("App Session End");
                            import('./helpers/trackAnalytics')
                                .then(function (_a) {
                                var trackBrazeEvents = _a.trackBrazeEvents;
                                trackBrazeEvents('App Session End', true);
                            });
                        });
                    }
                    return [2 /*return*/];
                });
            }); })
                .catch(function (err) {
                console.log(err, "error in initialising braze sdk");
            });
        }
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        // Send data to the service worker
        if ('serviceWorker' in navigator) {
            (_a = navigator.serviceWorker.controller) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'app_data', payload: (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.analytics) === null || _d === void 0 ? void 0 : _d.firebaseConfig });
        }
        if (typeof window !== "undefined") {
            import('./fetchBulkEntitlement').then(function (_a) {
                var getBulkEntitlementData = _a.getBulkEntitlementData;
                getBulkEntitlementData();
            });
        }
    }, []);
    // useEffect(() => {
    //   window.addEventListener('load', () => {
    //     setTimeout(() => {
    //       const entries = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
    //       const SLOW_ASSET_THRESHOLD = 900; // ms
    //       const slowAssets = entries
    //         .filter(entry =>
    //           entry.initiatorType !== 'xmlhttprequest' && entry.duration > SLOW_ASSET_THRESHOLD
    //         )
    //         .map(entry => ({
    //           name: entry.name,
    //           initiatorType: entry.initiatorType,
    //           transferSize: entry.transferSize,
    //           duration: entry.duration,
    //         }));
    //         const vitals = {
    //           LCP: performance.getEntriesByName('largest-contentful-paint')[0]?.startTime,
    //           FID: (performance.getEntriesByName('first-input')[0] as PerformanceEventTiming)?.processingStart,
    //           CLS: performance.getEntriesByType('layout-shift')
    //           .reduce((a, b) => a + (b as LayoutShift).value, 0),
    //           slowAssets : slowAssets
    //         };
    //       if (slowAssets.length > 0) {
    //         navigator.sendBeacon('/performance', JSON.stringify(vitals));
    //       }
    //     }, 0);
    //   });
    // }, []);
    // const lcp = useRef<number | undefined>();
    // const fid = useRef<number | undefined>();
    // const cls = useRef(0);
    // useEffect(() => {
    //   let lcpObserver: PerformanceObserver;
    //   let fidObserver: PerformanceObserver;
    //   let clsObserver: PerformanceObserver;
    //   if ('PerformanceObserver' in window) {
    //     // LCP
    //     lcpObserver = new PerformanceObserver((list) => {
    //       const entries = list.getEntries();
    //       const lastEntry = entries[entries.length - 1];
    //       lcp.current = lastEntry.startTime;
    //     });
    //     lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
    //     // FID
    //     fidObserver = new PerformanceObserver((list) => {
    //       const entry = list.getEntries()[0] as PerformanceEventTiming;
    //       if (entry) {
    //         fid.current = entry.processingStart - entry.startTime;
    //       }
    //     });
    //     fidObserver.observe({ type: 'first-input', buffered: true });
    //     // CLS
    //     clsObserver = new PerformanceObserver((list) => {
    //       for (const entry of list.getEntries() as LayoutShift[]) {
    //         if (!entry.hadRecentInput) {
    //           cls.current += entry.value;
    //         }
    //       }
    //     });
    //     clsObserver.observe({ type: 'layout-shift', buffered: true });
    //   }
    //   window.addEventListener('load', () => {
    //     setTimeout(() => {
    //       const entries = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
    //       const SLOW_ASSET_THRESHOLD = 900;
    //       const slowAssets = entries
    //         .filter(entry =>
    //           entry.initiatorType !== 'xmlhttprequest' && entry.duration > SLOW_ASSET_THRESHOLD
    //         )
    //         .map(entry => ({
    //           name: entry.name,
    //           initiatorType: entry.initiatorType,
    //           transferSize: entry.transferSize,
    //           duration: entry.duration,
    //         }));
    //       const vitals = {
    //         LCP: lcp.current,
    //         FID: fid.current,
    //         CLS: cls.current,
    //         slowAssets,
    //       };
    //       if (slowAssets.length > 0) {
    //         try {
    //           const payload = JSON.stringify(vitals);
    //           console.log('[Vitals Payload]', payload);
    //           const sent = navigator.sendBeacon('/performance', payload);
    //           console.log('[Beacon Sent]', sent); // Should log `true`
    //         } catch (err) {
    //           console.error('[Beacon Error]', err);
    //         }
    //       }
    //     }, 0);
    //   });
    //   return () => {
    //     lcpObserver?.disconnect();
    //     fidObserver?.disconnect();
    //     clsObserver?.disconnect();
    //   };
    // }, []);
    useEffect(function () {
        if (typeof window === "undefined")
            return;
        import("./components/Snackbar").then(function (component) {
            // Snackbar = component.default
            setSnackbarComponent(function () { return component.default; });
            verifyMagicLink();
        });
    }, []);
    // handle magic link failure
    useEffect(function () {
        if (typeof window === undefined)
            return;
        pubsub.subscribe("magic-link", function (data) {
            var _a;
            (_a = snackbarRef === null || snackbarRef === void 0 ? void 0 : snackbarRef.current) === null || _a === void 0 ? void 0 : _a.openSnackbar({ message: ((data === null || data === void 0 ? void 0 : data.message) && JSON.parse(data === null || data === void 0 ? void 0 : data.message)), type: (data === null || data === void 0 ? void 0 : data.success) ? "success" : "error" }, 5000);
        });
    }, []);
    useEffect(function () {
        function loadSplash() {
            var _a, _b, _c, _d;
            var splashConfig = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.splashConfig;
            if (!splashConfig)
                return;
            var isObject = (typeof splashConfig === 'object' && !Array.isArray(splashConfig) && splashConfig !== null) ? true : false;
            if (!isObject)
                return;
            if (((_c = Object.keys(splashConfig)) === null || _c === void 0 ? void 0 : _c.length) <= 0)
                return;
            var activeSplash = (_d = Object.keys(splashConfig)) === null || _d === void 0 ? void 0 : _d.find(function (splash) { var _a; return (((_a = splashConfig[splash]) === null || _a === void 0 ? void 0 : _a.isActive) ? splash : null); });
            if (!activeSplash)
                return false;
            return setActiveSplash(activeSplash);
        }
        loadSplash();
        return function () { };
    }, []);
    useEffect(function () {
        function isUserAvailable(planId) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, isSubscribed, user, userPlanId, planDetails, plan;
                var _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, fetchUserDetails()];
                        case 1:
                            _a = _d.sent(), isSubscribed = _a.isSubscribed, user = _a.user;
                            if (!(planId && user && isSubscribed)) return [3 /*break*/, 3];
                            userPlanId = (_c = (_b = user === null || user === void 0 ? void 0 : user.subscription) === null || _b === void 0 ? void 0 : _b.subscriptionInfo) === null || _c === void 0 ? void 0 : _c.planId;
                            if (!(planId !== userPlanId)) return [3 /*break*/, 3];
                            return [4 /*yield*/, getPlanByPlanId(planId)];
                        case 2:
                            planDetails = _d.sent();
                            if (planDetails && (planDetails === null || planDetails === void 0 ? void 0 : planDetails.length)) {
                                plan = structuredPlan(planDetails[0]);
                                sessionStorage.setItem('currentPlan', JSON.stringify(plan));
                                setIsUpgrade(true);
                            }
                            _d.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        if (window && typeof (window) !== undefined) {
            var queryPlanId = searchParams.get('planId') || '';
            var popup = searchParams.get('popup') || '';
            if (location.pathname === "/" && queryPlanId && popup == 'upgradeSubscription') {
                isUserAvailable(queryPlanId);
                pubsub.subscribe("hide-upgrade-popup", function (data) {
                    if (data)
                        setIsUpgrade(false);
                });
            }
        }
    }, [location]);
    var pageSchema = {};
    var publisher = (_51 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsMain) === null || _51 === void 0 ? void 0 : _51.companyName;
    var publisherLogo = ((_53 = (_52 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsPlatform) === null || _52 === void 0 ? void 0 : _52.images) === null || _53 === void 0 ? void 0 : _53.desktopLogo) ? ((_55 = (_54 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsPlatform) === null || _54 === void 0 ? void 0 : _54.images) === null || _55 === void 0 ? void 0 : _55.desktopLogo) + '?impolicy=resize&w=960&h=540' : "";
    pageSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": ((_57 = (_56 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _56 === void 0 ? void 0 : _56.metadataMap) === null || _57 === void 0 ? void 0 : _57.title) || ((_58 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _58 === void 0 ? void 0 : _58.title),
        "url": "https://".concat(browserDetails === null || browserDetails === void 0 ? void 0 : browserDetails.host).concat((_59 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.path) !== null && _59 !== void 0 ? _59 : ""),
        "description": ((_61 = (_60 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _60 === void 0 ? void 0 : _60.metadataMap) === null || _61 === void 0 ? void 0 : _61.description) || ((_62 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _62 === void 0 ? void 0 : _62.title),
        "publisher": {
            "@type": "Organization",
            "name": publisher,
            "logo": {
                "@type": "ImageObject",
                "url": publisherLogo
            }
        }
    };
    var _73 = useMemo(function () {
        var _a, _b, _c, _d, _e;
        if (pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.error) {
            return {};
        }
        var originalPageData = JSON.parse(JSON.stringify(pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page));
        var pageDataClone = JSON.parse(JSON.stringify(originalPageData));
        var mastheadData = (_a = originalPageData === null || originalPageData === void 0 ? void 0 : originalPageData.modules) === null || _a === void 0 ? void 0 : _a.filter(function (module) { return module.moduleType === "MastheadModule"; });
        var remainingData = (_b = originalPageData === null || originalPageData === void 0 ? void 0 : originalPageData.modules) === null || _b === void 0 ? void 0 : _b.filter(function (module) { return module.moduleType !== "MastheadModule"; });
        originalPageData.modules = remainingData;
        var isVerticalMasthead = false;
        var horizontalMasthead = false;
        if ((mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.length) > 0) {
            var placement = (_e = (_d = (_c = mastheadData[0]) === null || _c === void 0 ? void 0 : _c.layout) === null || _d === void 0 ? void 0 : _d.settings) === null || _e === void 0 ? void 0 : _e.navigationPlacement;
            if (placement === "Left") {
                isVerticalMasthead = true;
            }
            else {
                horizontalMasthead = true;
            }
        }
        var VerticalMasthead = null;
        var Masthead = null;
        if (isVerticalMasthead) {
            VerticalMasthead = loadable(function () { return import('./modules/VerticalMasthead'); }, { ssr: true });
        }
        if (horizontalMasthead) {
            Masthead = loadable(function () { return import('./modules/MastheadModule'); }, { ssr: true });
        }
        return {
            VerticalMasthead: VerticalMasthead,
            isVerticalMasthead: isVerticalMasthead,
            Masthead: Masthead,
            originalPageData: originalPageData,
            pageDataClone: pageDataClone,
            horizontalMasthead: horizontalMasthead,
            mastheadData: mastheadData
        };
    }, [pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page]), VerticalMasthead = _73.VerticalMasthead, Masthead = _73.Masthead, isVerticalMasthead = _73.isVerticalMasthead, originalPageData = _73.originalPageData, pageDataClone = _73.pageDataClone, mastheadData = _73.mastheadData, horizontalMasthead = _73.horizontalMasthead;
    if (pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.error) {
        return (React.createElement(Html, { "data-testid": "html", xApiKey: xApiKey, cachedAPI: cachedAPI, sseBaseUrl: sseBaseUrl, siteConfig: siteConfig, pageData: pageMetaData, browserDetails: browserDetails, title: (_63 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsMain) === null || _63 === void 0 ? void 0 : _63.site, apiBaseUrl: apiBaseUrl, analyticsBaseUrl: analyticsBaseUrl, wssBaseUrl: wssBaseUrl, env: env, ip: ip, embedCodeToken: embedCodeToken, toolsUrl: toolsUrl, templateUrl: templateUrl, requestId: requestId },
            React.createElement(Suspense, null,
                React.createElement(ErrorBoundary, { fallback: React.createElement("div", null, "Error loading component") },
                    React.createElement("div", { className: "main" },
                        React.createElement(NotFound404, null))))));
    }
    else {
        return (React.createElement(Html, { "data-testid": "html", xApiKey: xApiKey, cachedAPI: cachedAPI, sseBaseUrl: sseBaseUrl, siteConfig: siteConfig, pageData: pageMetaData, browserDetails: browserDetails, title: (_64 = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsMain) === null || _64 === void 0 ? void 0 : _64.site, apiBaseUrl: apiBaseUrl, analyticsBaseUrl: analyticsBaseUrl, wssBaseUrl: wssBaseUrl, env: env, ip: ip, embedCodeToken: embedCodeToken, toolsUrl: toolsUrl, templateUrl: templateUrl, requestId: requestId },
            React.createElement(Suspense, null,
                React.createElement("noscript", { dangerouslySetInnerHTML: {
                        __html: "\n              <style>\n                .skip-nav-noscript {\n                  position: static;\n                  display: block;\n                  background: #3c763d;\n                  color: white;\n                  padding: 10px;\n                  text-decoration: underline;\n                }\n              </style>\n              <a href=\"#main\" class=\"skip-nav-noscript\">Skip to main content</a>\n            ",
                    } }),
                React.createElement(NavFocusSkipper, null),
                React.createElement(Helmet, null,
                    React.createElement("script", { type: "application/ld+json" }, JSON.stringify(pageSchema))),
                activeSplash ? React.createElement(SplashLoader, { name: activeSplash }) : false,
                React.createElement(PersonalizationBanner, null),
                React.createElement(CmsMenu, null),
                shouldShowLocationModal && React.createElement(LocationServicesModal, null),
                isUpgrade ? React.createElement(UpgradeWrapper, { metadataMap: "", isViewplans: false }) : React.createElement(React.Fragment, null),
                isTveEnabled && React.createElement(V2TveLogin, { previouslyFocusedElement: previouslyFocusedElement, type: "TveModule" }),
                isVerticalMasthead ? React.createElement(VerticalMasthead, { tabIndex: -1, pageData: (_65 = pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.page) === null || _65 === void 0 ? void 0 : _65.modules, siteConfig: siteConfig, moduleData: mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData[0] }) : React.createElement(React.Fragment, null),
                horizontalMasthead ? React.createElement(Masthead, { pageData: pageDataClone, siteConfig: siteConfig, moduleData: mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData[0] }) : React.createElement(React.Fragment, null),
                React.createElement("main", { id: "main" },
                    React.createElement("div", { className: "modules-wrapper", style: isVerticalMasthead ? { marginLeft: '250px' } : {} },
                        SnackbarComponent && React.createElement(SnackbarComponent, { ref: snackbarRef }),
                        React.createElement(LazyLoadModules, { browserDetails: browserDetails, offset: 4, pageData: originalPageData, pathName: pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.path, siteConfig: siteConfig }))),
                VLCookieConsent && !disableVlCookieConsent && React.createElement(VLCookieConsent, { genericMessage: configMessages }))));
    }
};
